import React, { useLayoutEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// Containers
import Verificacion from '../containers/Step1';
import DatosPersonales from '../containers/Step2';
import Sucursal from '../containers/Step4';
import Comprobante from '../containers/Step5';
import CasosBorderThemplate from '../components/templates/CasosBorde';
import CasosBordeTemplateConexion from '../components/templates/CasosBordeConexion';
import CasosBorderThemplateListaNegra from '../components/templates/CasoBordeListaNegra';
import UsuarioConTCThemplate from '../components/templates/UsuarioConTC';
import BlackCardFinalizada from '../components/atoms/BlackCardFinalizada';
import GoldCardFinalizada from '../components/atoms/GoldCardFinalizada';
import BlackCard from '../components/atoms/BlackCard';
import GoldCard from '../components/atoms/GoldCard';
import BlueCard from '../components/atoms/BlueCard';
import HazteSocio from '../components/atoms/HazteSocio';
import Loader from '../components/atoms/Loader';
import CasoBordeSolicitudProceso from '../components/templates/CasoBordeSolicitudProceso';
import CasoBordeCedulaNoValida from '../components/templates/CasoBordeCedulaNoValida';
import Header from '../components/organisms/Header';

// Atoms
import Menu from '../components/atoms/Menu';

// Style
import StyledPages from './styles';
import '@design-system-coopeuch/web/dist/index.css'
import '@design-system-coopeuch/assets/css/custom.css'

const App = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <StyledPages>
      <Helmet>
        <title>Cooperativa | Coopeuch</title>
      </Helmet>
      <Header />
      <section className="contenedor-solitud-tc">
        <Loader />
        <Router>
          <Menu />
          <Switch>
            <Route path="/" exact component={Verificacion} />
            <Route path="/verificacion/error" exact component={CasosBorderThemplate} />
            <Route path="/verificacion/error/usuario-con-tc/gold" exact>
              <UsuarioConTCThemplate tarjeta="gold" />
            </Route>
            <Route path="/verificacion/error/usuario-con-tc/black" exact>
              <UsuarioConTCThemplate tarjeta="black" />
            </Route>
            <Route path="/datos-personales" exact component={DatosPersonales} />
            <Route path="/datos-personales/error" exact component={CasosBorderThemplateListaNegra} />
            <Route path="/tu-futura-tarjeta/mastercard/black" exact component={BlackCard} />
            <Route path="/tu-futura-tarjeta/finalizada/black" exact component={BlackCardFinalizada} />
            <Route path="/tu-futura-tarjeta/mastercard/gold" exact component={GoldCard} />
            <Route path="/tu-futura-tarjeta/finalizada/gold" exact component={GoldCardFinalizada} />
            <Route path="/tu-futura-tarjeta/dale" exact component={BlueCard} />
            <Route path="/tu-futura-tarjeta/hazte-socio" exact component={HazteSocio} />
            <Route path="/sucursal" exact component={Sucursal} />
            <Route path="/comprobante" exact component={Comprobante} />
            <Route path="/error" exact component={CasosBorderThemplate} />
            <Route path="/error/cedula-no-valida" exact component={CasoBordeCedulaNoValida} />
            <Route path="/error-conexion" exact component={CasosBordeTemplateConexion} />
            <Route path="/solicitud-en-proceso" exact component={CasoBordeSolicitudProceso} />
            <Route component={Verificacion} />
          </Switch>
        </Router>
      </section>
    </StyledPages>
  );
};

export default App;
